import GoogleMapReact from "google-map-react";
import ConcesionarioPoint from "./ConcesionarioPoint";
import "./css/map.css";

function Layout({ x, y, z, apikey, ciudad, setCiudad, setLatitud, setLongitud, setZoom, concesionarios, ciudadesPoint, setConcesionarios, setConcesionario, setConcesionarioc }) {

  return (
    <div className="cont-map">
      {
        (ciudad === "100") ?
          <GoogleMapReact
            bootstrapURLKeys={{ key: apikey }}
            center={{ lat: x, lng: y }}
            zoom={z}
          >
            {
              concesionarios.map(concesionario => (
                <ConcesionarioPoint
                  key={concesionario.CIU_CODIGO}
                  lat={concesionario.CIU_LATITUD_POINT}
                  lng={concesionario.CIU_LONGITUD_POINT}
                  name={concesionario.CIU_NOMBRE}
                  codigo={concesionario.CIU_CODIGO}
                  empresaNombre=""
                  almacen=""
                  telefono=""
                  contacto=""
                  email=""
                  telefono_con=""
                  setCiudad={setCiudad}
                  setLatitud={setLatitud}
                  setLongitud={setLongitud}
                  setZoom={setZoom}
                  ciudadesPoint={ciudadesPoint}
                  concesionarios={concesionarios}
                  setConcesionarios={setConcesionarios}
                  setConcesionario={setConcesionario}
                  setConcesionarioc={setConcesionarioc}
                  color="#002c5f"
                  tipo="ciudad"
                  empresa={concesionario.CIU_CODIGO}
                  imagen={"taller.jpg"}
                />
              ))
            }
          </GoogleMapReact>
          :
          <GoogleMapReact
            bootstrapURLKeys={{ key: apikey }}
            center={{ lat: x, lng: y }}
            zoom={z}
          >
            {
              concesionarios.map(concesionario => (
                <ConcesionarioPoint
                  key={concesionario.ALM_CODIGO / concesionario.ALM_EMPRESA}
                  lat={concesionario.ALM_LATITUD}
                  lng={concesionario.ALM_LONGITUD}
                  name={concesionario.ALM_NOMBRE}
                  codigo={concesionario.ALM_CODIGO}
                  empresaNombre={concesionario.EMP_NOMBRE_COMERCIAL}
                  telefono={concesionario.ALM_TELEFONO}
                  contacto={concesionario.ALM_CONTACTO_TALLER}
                  email={concesionario.ALM_EMAIL_CONTACTO_TALLER}
                  telefono_con={concesionario.ALM_TELEFONO_CONTACTO_TALLER}
                  setCiudad={setCiudad}
                  setLatitud={setLatitud}
                  setLongitud={setLongitud}
                  setZoom={setZoom}
                  ciudadesPoint={ciudadesPoint}
                  concesionarios={concesionarios}
                  setConcesionarios={setConcesionarios}
                  setConcesionario={setConcesionario}
                  setConcesionarioc={setConcesionarioc}
                  color="#002c5f"
                  tipo="concesionario"
                  empresa={concesionario.ALM_EMPRESA}
                  imagen={"taller.jpg"}
                />
              ))
            }
          </GoogleMapReact>
      }
    </div>
  );
}
export default Layout;